import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue'
import i18n from './plugins/i18n' // Importa la configuración
// main.js
import './style.css';

//import vuetify from './plugins/vuetify'
import vuetify from './temaVuetify.js'; // Ruta al archivo con el tema
import { loadFonts } from './plugins/webfontloader'
import store from './store';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import ComponenteCatalogo from './components/ComponenteCatalogo.vue';
import ComponenteOnBoarding from './components/ComponenteOnBoarding.vue';


loadFonts()

const routes = [        
      { path: '/catalogo', name: 'ComponenteCatalogo', component: ComponenteCatalogo},  
      { path: '/', name: 'ComponenteHome', component: ComponenteOnBoarding},   
      { path: '/onboarding', name: 'ComponenteOnBoarding', component: ComponenteOnBoarding},   
];

const router = createRouter({
  history: createWebHistory(),  
  routes: routes,
});

const app = createApp(App)
app.use(i18n);


fetch('/config.json')
  .then((response) => response.json())
  .then((config) => {
   
    // Proveer la configuración globalmente
    app.provide('config', config);

  })
  .catch((error) => {
    console.error('Error loading configuration:', error);
  });


router.beforeEach((to, from, next) => {  

  document.title = to.meta.title || 'Informes Simulart';
  
  let faviconUrl = to.meta.favicon || '/favicon.ico';
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = faviconUrl;

  const isAuthenticated = store.state.usuarioAutenticado; 

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {             
    console.log("A Login")
    next('/login')
  } else {
    console.log("A Home")
    next()
  }
});





import VMdPreview from '@kangc/v-md-editor/lib/preview';

// highlightjs
import hljs from 'highlight.js';
import githubTheme from "@kangc/v-md-editor/lib/theme/github.js";
import '@kangc/v-md-editor/lib/theme/style/github.css'

VMdPreview.use(githubTheme, {
  Hljs: hljs,
});


import '@vue-flow/core/dist/style.css' // Estilos base de VueFlow
import '@vue-flow/core/dist/theme-default.css'

//createApp(App)
app.use(VueSweetalert2);

app.use(router)
app.use(vuetify)
app.use(store)
app.component('VueDatePicker', VueDatePicker);
app.use(createPinia())
app.mount('#app')
app.use(VMdPreview);

// Codigo preparado para reCAPTCHA (descomentar cuando esté en prod)
import { VueReCaptcha } from 'vue-recaptcha-v3'
app.use(VueReCaptcha, { siteKey: '6Ldio8wsAAAAAOQGNjK8_QNcI9bC35CGSTqNojmF' })

   



